import React, { Component } from "react";
import { Card, CardBody } from "reactstrap";
import 'components/Widgets/widget-style.css';
import { uuidv4 } from "components/Notebook/operations/notebook";

class CardWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cData : props.widgetItem
        }
    }

    componentDidMount(){
    }

    getWrapperClass = (theme) => {
        switch(theme) {
            case "primary":
                return "wd-primary text-white";
            case "info":
                return "wd-info text-white";
            case "success":
                return "wd-success text-white";
            case "warning":
                return "wd-warning text-white";
            case "danger":
                return "wd-danger text-white";
            case "light":
                return "wd-light wd-title text-dark";
            default:
                return "wd-default wd-title text-dark"
        }
    }

    render () {
        let renderData = this.state.cData.bind;
        let objsData = {};
        if (renderData.hasOwnProperty("data")) {
            if (renderData.data !== null && renderData.data !== undefined) {
                var parsedData = renderData.data;
                // Data from URL
                if (typeof parsedData === "object") {
                        objsData = parsedData;
                }
                // Data from JSON
                else {
                        objsData = JSON.parse(parsedData);
                }
            }
        }
      return (
        <div className="maindiv">
                  <div className="subdiv" key={uuidv4()}>
                      <div className="card-wid">
                          <Card className={`w-card m-0 ${this.getWrapperClass(this.props.widgetItem.theme !== null && this.props.widgetItem.theme !== undefined && this.props.widgetItem.theme.length > 0 ? this.props.widgetItem.theme : 'bg-success')}`}>
                              <CardBody>
                              <div className="d-flex">
                                  <div className="d-block w-100">
                                      <div>
                                          <p className={`title wd-sm-title m-0 text-capitalize font-weight-bold mb-2 ${objsData.title !== null && objsData.title !== undefined && objsData.title !== "" ? "" : "font-weight-normal text-danger font12"}`}>{objsData.title !== null && objsData.title !== undefined && objsData.title !== "" ? objsData.title : 
                                        <span>widget render failed</span>
                                          } </p>
                                          <p className={`h1 m-0 text-capitalize font-weight-bold ${objsData.value !== null && objsData.value !== undefined ? '' : 'h5 text-danger font12'}`}> {objsData.value !== null && objsData.value !== undefined && objsData.value !== "" ? objsData.value : ""} </p>
                                      </div>
                                  </div>
                              </div>

                              </CardBody>
                          </Card>
                      </div>
                  </div>
              {/* ))} */}
        </div>
      )
    }
}





export default CardWidget;